import Nextjs from './nextjs';

export default Nextjs;
